import React from 'react';
import PropTypes from 'prop-types';

import { Modal } from 'semantic-ui-react';
import Spinner from '../../../../components/Spinner';
import Button from '../../../../components/Button';

import './styles.scss';

export const BulkMigrateModal = props => {
    return (
        <Modal className="bulk-migrate-modal" open={props.openModal} onClose={props.onModalClose} closeIcon={true}>
            <Modal.Header className="bulk-migrate-header">Bulk Migrate</Modal.Header>
            <Modal.Content className="bulk-migrate-content">
                <div className="content-wrapper">
                    <div className="content-title">
                        Are you sure you want to migrate {props.selectedJobs.length} job{props.selectedJobs.length === 1 ? '' : 's'} to {props.platform} ?
                    </div>
                    {
                        !props.isLoading ? (
                            <div className="content-actions">
                                <Button skin='dark' text='Confirm' clickButton={props.onMigrateConfirm} />
                                <Button skin='light' text='Cancel' clickButton={props.onMigrateCancel} />
                            </div>
                        ): (
                            <div className="spinner-wrapper">
                                <Spinner />
                                <p>Please Wait...</p>
                            </div>
                        )
                    }
                </div>
            </Modal.Content>
        </Modal>
    )
}

BulkMigrateModal.propTypes = {
    openModal: PropTypes.bool.isRequired,
    onModalClose: PropTypes.func.isRequired,
    selectedJobs: PropTypes.array.isRequired,
    isLoading: PropTypes.bool,
    onMigrateCancel: PropTypes.func,
    onMigrateConfirm: PropTypes.func,
}